package com.essntl.features.paymentparameter.data.supabase

import com.essntl.features.paymentparameter.domain.model.PaymentParameterModel
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
internal data class PaymentParameterDto(
    val id: String,
    @SerialName("created_at")
    val createdAt: String,
    val name: String?,
    val amount: Int?,
    @SerialName("is_invoice")
    val isInvoice: Boolean?,
    @SerialName("qb_item_id")
    val qbItemId: String?,
    val method: String?,
    val type: String?,
    @SerialName("apply_to_amount")
    val applyToAmount: Boolean?,
) {
    fun toModel() =
        PaymentParameterModel(
            id = id,
            createdAt = createdAt,
            name = name,
            amount = amount,
            isInvoice = isInvoice,
            applyToAmount = applyToAmount,
            qbItemId = qbItemId,
            method = when (method) {
                "ADD" -> PaymentParameterModel.Method.Add
                "SUBSTRACT" -> PaymentParameterModel.Method.Substract
                else -> null
            },
            type = when (type) {
                "FLAT_FEE" -> PaymentParameterModel.Type.FlatFee
                "PERCENTAGE" -> PaymentParameterModel.Type.Percentage
                else -> null
            },
        )
}

internal fun PaymentParameterModel.Method.toDto() =
    when (this) {
        PaymentParameterModel.Method.Add -> "ADD"
        PaymentParameterModel.Method.Substract -> "SUBSTRACT"
    }

internal fun PaymentParameterModel.Type.toDto() =
    when (this) {
        PaymentParameterModel.Type.FlatFee -> "FLAT_FEE"
        PaymentParameterModel.Type.Percentage -> "PERCENTAGE"
    }
